export enum StaffRole {
  COACH = 'Coach',
  HEAD_COACH = 'Head Coach',
  ASSISTANT_COACH = 'Assistant Coach',
  GOALKEEPER_COACH = 'Goalkeeper Coach',
  PHYSIOTHERAPIST = 'Physiotherapist',
  DOCTOR = 'Doctor',
  TEAM_MANAGER = 'Team Manager',
  ANALYST = 'Analyst',
  SCOUT = 'Scout',
  OTHER = 'Other',
}

export interface StaffMember {
  id?: number;
  clId?: string;
  givenName?: string;
  surName?: string;
  displayName?: string;
  role?: StaffRole;
  roleDisplayName?: string;
  birthDay?: string;
  nationality?: string;
  imageUrl?: string;
}
